export function getTotalPages(pageSize?: number, totalItems?: number): number {
  if (!pageSize || !totalItems) {
    return 0;
  }
  return Math.ceil(totalItems / pageSize);
}
